import {App} from '../app'
import {saveAsXlsx} from 'yougile-util'
import {FileChooser} from '../../../../common/file-chooser'
import {FileUploadProgress} from '../../../components/file-upload-progress'

export const browserInitApp = () => {
  App.init(
    saveAsXlsx,
    (cb: (file: File) => void) => FileChooser.chooseFile(undefined, true, cb),
    FileUploadProgress.addFile,
    FileUploadProgress.updateProgress,
    FileUploadProgress.removeFile
  )
}
